/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, FormLabel } from "@mui/material";
import { FC, type JSX } from "react";

import TestIds from "../../../testIds";

import styles from "./FormControlLabel.module.scss";

export type TLabelColor = "primary" | "secondary";

export interface IFormControlLabelProps {
  "data-testid"?: string;
  htmlFor?: string;
  required?: boolean;
  children?: React.ReactNode;
  color?: TLabelColor;
}

const FormControlLabel: FC<IFormControlLabelProps> = ({
  "data-testid": testId,
  htmlFor,
  children,
  required,
  color = "primary",
}: IFormControlLabelProps): JSX.Element => {
  return (
    <FormLabel
      data-testid={TestIds.components.formControls.label.component(testId)}
      htmlFor={htmlFor}
      className={`${styles.flFormControlLabel} ${styles[`flFormControlLabel__${color}`]}`.trim()}
    >
      {children}
      {!required && (
        <Box
          component="span"
          className={styles.flFormControlLabel__optional}
          data-testid={TestIds.components.formControls.label.optional}
        >
          (optional)
        </Box>
      )}
    </FormLabel>
  );
};

export default FormControlLabel;
